import React from "react";
import { compose } from "redux";
import classNames from "classnames";
import { Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core";

const CalendarPlaceholderDay = ({ width }) => {
  const classes = useStyles({ width });

  return (
    <Grid
      item
      container
      className={classNames(classes.root, {
        [classes.dateFullwidth]: !width,
      })}
    />
  );
};

const useStyles = makeStyles(theme => ({
  root: {
    padding: 1,
    position: "relative",
    width: ({ width }) => (width ? width : "100%"),
    boxShadow: `inset 0px 0px 1px 1px ${theme.palette.grey[100]}`,
  },
}));

export default compose(React.memo)(CalendarPlaceholderDay);
